import { array, coerce, Infer, instance, integer, number, string, type, enums, optional } from 'superstruct';
import { PublicKey } from '@solana/web3.js';
import JSBI from 'jsbi';

export const PublicKeyFromString = coerce(instance(PublicKey), string(), (value) => new PublicKey(value));

//@ts-ignore bug because JSBI ctor being private?!?
export const AmountFromString = coerce<JSBI, null, string>(instance(JSBI), string(), (value) => JSBI.BigInt(value));

export const NumberFromString = coerce<string, null, number>(string(), number(), (value) => new Number(value));

export type SwapInfo = Infer<typeof SwapInfo>;
export const SwapInfo = type({
  ammKey: PublicKeyFromString,
  label: string(),
  inputMint: string(),
  outputMint: string(),
  inAmount: AmountFromString,
  outAmount: AmountFromString,
  feeAmount: AmountFromString,
  feeMint: PublicKeyFromString,
});

export type RoutePlanStep = Infer<typeof RoutePlanStep>;
export const RoutePlanStep = type({
  swapInfo: SwapInfo,
  percent: integer(),
});
export type RoutePlanWithMetadata = Infer<typeof RoutePlanWithMetadata>;
export const RoutePlanWithMetadata = array(RoutePlanStep);

export type QuoteResponse = Infer<typeof QuoteResponse>;
export const QuoteResponse = type({
  inputMint: PublicKeyFromString,
  inAmount: AmountFromString,
  outputMint: PublicKeyFromString,
  outAmount: AmountFromString,
  otherAmountThreshold: AmountFromString,
  priceImpactPct: NumberFromString,
  swapMode: enums(['ExactIn', 'ExactOut']),
  routePlan: RoutePlanWithMetadata,
  slippageBps: number(),
  contextSlot: number(),
  computedAutoSlippage: optional(number()),
});

export type QuoteResponseMeta = {
  quoteResponse: QuoteResponse;
  original: any;
};
